import '../index.css';

export default function Hero() {
  return (
    <section className="hero-section">
      <div className="section-inner">
        <div className="hero-badge">
          ⭐ ORIGINAL • DIRETO DA GRINGA • A ÚNICA 100% FUNCIONANDO
        </div>

        <img
          src="https://static.lumi.new/d2/d2c11a555f13515f311cbfe03b2f4b1a.webp"
          alt="Mestre Lovable Infinity Logo"
          className="hero-logo" />


        <h1 className="hero-title">
          Use o Lovable Ilimitado com a<br />
          Extensão <span className="brand-gold">Mestre Lovable Ilimitado - O RETORNO</span>
        </h1>

        <p className="hero-subtitle">
          Instale em 2 minutos, digite no chat da extensão o que você quer e use <strong>ilimitado</strong>, 
          sem gastar créditos da sua conta Lovable.
        </p>

        <div className="hero-features">
          <div className="hero-feature">
            <span className="feature-icon-hero">✕</span>
            <span>Sem comprar créditos</span>
          </div>
          <div className="hero-feature">
            <span className="feature-icon-hero">✕</span>
            <span>Sem assinatura em dólar</span>
          </div>
          <div className="hero-feature highlight">
            <span className="feature-icon-hero">✓</span>
            <span>Uso ilimitado</span>
          </div>
        </div>

        <p className="hero-compatibility">Funciona no Chrome, Firefox, Edge e Brave</p>
      </div>
    </section>);

}